import { Project } from '@ih/app/shared/apis/interfaces';

export class SetProject {
  public static readonly type = '[Project] SetProject';
  constructor(public readonly project: Project | null) {}
}
